"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyRoundness = exports.radiuses = void 0;
var styled_components_1 = require("styled-components");
/**
 * Набор часто встречающихся скруглений.
 */
exports.radiuses = {
    250: 15.625,
    32: 2,
    28: 1.75,
    24: 1.5,
    20: 1.25,
    18: 1.125,
    16: 1,
    14: 0.875,
    12: 0.75,
    8: 0.5,
    0: 0,
};
/**
 * Миксин скругленности.
 */
exports.applyRoundness = function (_a) {
    var roundness = _a.roundness;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-radius: ", "rem;\n    "], ["\n        border-radius: ", "rem;\n    "])), exports.radiuses[roundness]);
};
var templateObject_1;
//# sourceMappingURL=applyRoundness.js.map